<template>
  <v-container nowrap grid-list-md>
    <v-flex xs12 class="px-0">
      <span class="font-weight-bold">Endereço do Cliente</span>
    </v-flex>
    <v-layout wrap>
      <v-flex xs12 sm4 md2>
        <v-text-field
          id="cep"
          v-model="cep"
          label="CEP"
          mask="#####-###"
          @change="buscaCep($event)"
          :readonly="cep !== '' && !proposal_validation.can_subscription"
          :disabled="cep !== '' && !proposal_validation.can_subscription"
          required
          :rules="[
            (v) => v?.length > 7 || 'Ops. Parece que esse não é um CEP válido',
          ]"
        >
          <template v-slot:append>
            <v-progress-circular
              v-if="loading_cep"
              indeterminate
              color="primary"
              size="18"
            ></v-progress-circular>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm8 md5>
        <v-text-field
          id="logradouro"
          v-model="logradouro"
          label="Logradouro"
          :readonly="logradouro !== '' && !proposal_validation.can_subscription"
          :disabled="logradouro !== '' && !proposal_validation.can_subscription"
          required
          :rules="[
            (v) => !!v || 'Por favor, determine o logradouro do endereço.',
          ]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md2>
        <v-text-field
          id="numero"
          v-model="numero"
          label="Número"
          type="number"
          :readonly="numero !== '' && !proposal_validation.can_subscription"
          :disabled="numero !== '' && !proposal_validation.can_subscription"
          required
          :rules="[(v) => !!v || 'Por favor, determine o número do endereço.']"
          @keydown="preventNumberChange"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-text-field
          id="complemento"
          v-model="complemento"
          label="Complemento"
          hint="Opcional"
          :readonly="
            complemento !== '' && !proposal_validation.can_subscription
          "
          :disabled="
            complemento !== '' && !proposal_validation.can_subscription
          "
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-text-field
          id="bairro"
          v-model="bairro"
          label="Bairro"
          :readonly="bairro !== '' && !proposal_validation.can_subscription"
          :disabled="bairro !== '' && !proposal_validation.can_subscription"
          required
          :rules="[(v) => !!v || 'Por favor, determine o bairro do endereço.']"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <v-text-field
          id="localidade"
          v-model="localidade"
          label="Cidade"
          :readonly="localidade !== '' && !proposal_validation.can_subscription"
          :disabled="localidade !== '' && !proposal_validation.can_subscription"
          required
          :rules="[(v) => !!v || 'Por favor, determine a cidade do endereço.']"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <v-autocomplete
          :items="states"
          item-text="name"
          item-value="initials"
          label="Estado"
          prepend-icon="map"
          v-model="state"
          return-object
          hint="Selecione o estado"
          :readonly="state !== '' && !proposal_validation.can_subscription"
          :disabled="state !== '' && !proposal_validation.can_subscription"
          required
          :rules="[(v) => !!v || 'Por favor, determine o estado do endereço.']"
        ></v-autocomplete>
      </v-flex>
    </v-layout>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import statesfile from "@/model/state";
import { getCEP } from "../../../services/getCep";

export default {
  name: "CustomerDadosPessoaisForm",

  props: {
    selected_cep: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    cepUpdate: 0,
    loading_cep: false,
    states: statesfile.estados,
    valid: false,
    loading: false,
    snack: {
      color: null,
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    },
  }),

  computed: {
    ...mapState("sales", ["user", "proposal_validation"]),
    cep: {
      get() {
        this.cepUpdate;
        return this.$store?.state?.sales?.user?.address?.postal_code;
      },
      set(value) {
        this.$store.commit("sales/setCEP", value);
      },
    },
    logradouro: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.address;
      },
      set(value) {
        this.$store.commit("sales/setLogradouro", value);
      },
    },
    numero: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.address_number;
      },
      set(value) {
        this.$store.commit("sales/setNumero", value);
      },
    },
    complemento: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.address_complement;
      },
      set(value) {
        this.$store.commit("sales/setComplemento", value);
      },
    },
    bairro: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.district;
      },
      set(value) {
        this.$store.commit("sales/setBairro", value);
      },
    },
    localidade: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.city;
      },
      set(value) {
        this.$store.commit("sales/setLocalidade", value);
      },
    },
    state: {
      get() {
        this.cepUpdate;
        return this.$store.state.sales.user?.address?.state;
      },
      set(value) {
        this.$store.commit("sales/setState", value);
      },
    },
  },

  watch: {
    selected_cep() {
      this.cep = this.selected_cep;
      this.cepUpdate++;
    },
  },

  methods: {
    ...mapActions("sales", []),

    show_snack(message, color, ...args) {
      this.snack.top = true;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },

    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            if (result?.erro == true) {
              this.loading_cep = false;
              this.cepUpdate++;
            } else {
              this.logradouro = result.data.logradouro;
              this.complemento = result.data.complemento;
              this.bairro = result.data.bairro;
              this.localidade = result.data.localidade;
              this.state = this.states.find(
                (item) => item.initials === result.data.uf,
              );
              this.loading_cep = false;
              this.cepUpdate++;
            }
          })
          .catch(() => {
            this.loading_cep = false;
            this.cepUpdate++;
          });
      }
    },

    preventNumberChange(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
